<template>
    <transition v-if="items.length">
        <div class="inline-links-menu">
            <div class="inline-links-menu--dropdown" v-if="isMobile">
                <dropdown
                        :facets="['inline-links-menu']"
                        :open-icon="DROPDOWN_ICONS.open"
                        :closed-icon="DROPDOWN_ICONS.closed"
                        :label="title"
                        :items="items"/>
            </div>
            <nav class="inline-links-menu--content" v-else>
                <h2 class="inline-links-menu--title u-reset">
                    {{ title }}
                </h2>
                <ul class="inline-links-menu--collection u-reset">
                    <li class="inline-links-menu--item" v-for="(item, index) in items" :key="index">
                        <a class="inline-links-menu--link u-reset"
                                :class="getMenuLinkClasses(item, index)"
                                :href="item.path"
                                @click.prevent="scrollTo">
                            <span class="inline-links-menu--text">
                                {{ item.label }}
                            </span>
                            <span class="inline-links-menu--icon">
                                <ui-icon :symbol="getLockSymbol(item)" size="small" v-if="item.isLockedContent"/>
                            </span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </transition>
</template>

<script>
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import Dropdown from 'framework/global-components/dropdown/dropdown';
    import { UiIcon } from '@dreipol/vue-ui/src/components';
    import isMobileMixin from 'framework/mixins/is-mobile';

    export const DROPDOWN_ICONS = {
        open: {
            symbol: 'triangle-up',
            size: 'small',
        },
        closed: {
            symbol: 'more',
            size: 'medium',
        },
    };

    export default {
        components: { Dropdown, UiIcon },
        mixins: [bemMixin('inline-links-menu'), isMobileMixin],
        props: {
            title: {
                type: String,
                required: true,
            },
            activeSubtitleIndex: {
                type: Number,
                required: true,
            },
            items: {
                type: Array,
                required: true,
            },
            scrollTo: {
                type: Function,
                required: true,
            },
        },
        data() {
            return {
                DROPDOWN_ICONS,
            };
        },
        methods: {
            getLockSymbol(item) {
                return item.isEnabled ? 'unlocked' : 'locked';
            },
            getMenuLinkClasses(link, index) {
                return [
                    this.bemAdd(this.activeSubtitleIndex === index ? 'is-active' : 'base', 'link'),
                ];
            },
        },
    };
</script>
